import { render } from "./PaginationVue.vue?vue&type=template&id=4ce1eb99"
import script from "./PaginationVue.vue?vue&type=script&lang=js"
export * from "./PaginationVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__